import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useProgramGroups } from "../../api/programs-api";
import { useHistory } from "react-router-dom";

export const ProgramGroupsList = () => {
  const history = useHistory();
  const columns = [
    {
      field: "name",
      headerName: "Name",
      renderCell: (params: any) => {
        return (
          <div
            onClick={() => {
              history.push(`/program-groups/${params.id}`);
            }}
            style={{
              textDecoration: "underline",
              color: "blue",
              cursor: "pointer",
            }}
          >
            {params.value}
          </div>
        );
      },
      flex: 2,
    },
    {
      field: "isActive",
      headerName: "Active",
      renderCell: (params: any) => {
        return <div>{params.value?.toString() === "true" ? "YES" : "NO"}</div>;
      },
      flex: 0,
    },
    {
      field: "isVisibleToStandard",
      headerName: "Standard",
      renderCell: (params: any) => {
        return <div>{params.value?.toString() === "true" ? "YES" : "NO"}</div>;
      },
      flex: 0,
    },
    {
      field: "isVisibleToPremium",
      headerName: "Premium",
      renderCell: (params: any) => {
        return <div>{params.value?.toString() === "true" ? "YES" : "NO"}</div>;
      },
      flex: 0,
    },
    {
      field: "sortOrder",
      headerName: "SortOrder",
      renderCell: (params: any) => {
        return <div>{params.value || null}</div>;
      },
      flex: 0,
    },
  ];
  const { data } = useProgramGroups();
  return (
    <div style={{ height: 600, width: "100%" }}>
      {data ? (
        <DataGrid rows={data} columns={columns} disableSelectionOnClick />
      ) : (
        <div>loading...</div>
      )}
    </div>
  );
};
